export enum Role {
   ADMINISTRATOR = 'ADMINISTRATOR',
   USER = 'USER',
   REVIEWER = 'REVIEWER',
}

// AMAZONS3, AS2, AZURESTORAGE, BOX, DROPBOX, EMAIL, FTP, GOOGLECLOUD, HTTP, LOCAL, ORACLECLOUD, REMOTE, SHAREFILE, SMB
export enum TransportTypeName {
   AMAZONS3 = 'AMAZONS3',
   AZURESTORAGE = 'AZURESTORAGE',
   BOX = 'BOX',
   REMOTE = 'REMOTE',
   DROPBOX = 'DROPBOX',
   EMAIL = 'EMAIL',
   LOCAL = 'LOCAL',
   FTP = 'FTP',
   GOOGLECLOUD = 'GOOGLECLOUD',
   HTTP = 'HTTP',
   ORACLECLOUD = 'ORACLECLOUD',
   SHAREFILE = 'SHAREFILE',
   SHAREPOINT = 'SHAREPOINT',
   SMB = 'SMB',
   AS2 = 'AS2',
   BISCOM = 'BISCOM',
   ONEDRIVE = 'ONEDRIVE',
   WORKDRIVE = 'WORKDRIVE',
}

export enum ServerTypeName {
   AMAZONS3 = 'AMAZONS3',
   AZURESTORAGE = 'AZURESTORAGE',
   BOX = 'BOX',
   REMOTE = 'REMOTEAGENT',
   DROPBOX = 'DROPBOX',
   EMAIL = 'EMAIL',
   LOCAL = 'LOCAL',
   FTP = 'FTP',
   GOOGLECLOUD = 'GOOGLECLOUD',
   HTTP = 'HTTP',
   ORACLECLOUD = 'ORACLECLOUD',
   SHAREFILE = 'SHAREFILE',
   SHAREPOINT = 'SHAREPOINT',
   SMB = 'SMB',
   AS2 = 'AS2',
   BISCOM = 'BISCOM',
   ONEDRIVE = 'ONEDRIVE',
   WORKDRIVE = 'WORKDRIVE',
}
